export enum AiAnalysisStatus {
  Pending = 'Pending',
  Processing = 'Processing',
  Completed = 'Completed',
  Failed = 'Failed',
}
export interface AiAnalysisJob {
  id: string;
  inspectionItemId: string;
  scrapingJobId?: string;
  status: AiAnalysisStatus;
  valorEstimado?: number;
  valorMinimo?: number;
  valorMaximo?: number;
  valorM2Medio?: number;
  metodologia?: string;
  amostrasUtilizadas?: number;
  errorMessage?: string;
  createdAt: string;
  startedAt?: string;
  completedAt?: string;
  result?: unknown;
  resultJson?: string;
}

export interface AiAnalysisResult {
  status: 'success' | 'error';
  error?: string;
  scraping?: {
    total_encontrados: number;
    estatisticas?: Record<string, unknown>;
  };
  analise?: {
    status: 'success' | 'error';
    metodo?: string;
    tipologia?: string;
    tempo_execucao_ms?: number;
    total_imoveis_analisados?: number;
    resultado_target?: {
      imovel_id: string;
      tipologia: string;
      endereco: string;
      area_privativa: number;
      valor_estimado: number;
      valor_minimo: number;
      valor_maximo: number;
      valor_m2_medio: number;
      codigo_parecer: string;
      data_emissao: string;
      metodologia: string;
      observacoes?: string;
      amostras_utilizadas: number;
    };
    top5_scraping?: Array<{
      ranking: number;
      id: string;
      endereco: string;
      valor: number;
      area: number;
      valor_m2: number;
    }>;
  };
  deduplicacao?: {
    status: 'success' | 'error' | 'skipped';
    total_scraping: number;
    total_analisados: number;
    total_duplicatas: number;
    total_unicos: number;
  };
  vistoria_visual?: Array<{
    status: 'success' | 'error';
    id_imovel: string;
    ranking: number;
    tipo_imovel: string;
    padrao_acabamento: string;
    estado_conservacao: string;
    impressao_geral?: string;
  }>;
}

export interface AutomaticReportHeader {
  tituloDocumento: string;
  idLaudo: string;
  formatoLaudo: string;
}

export interface AutomaticReportDadosPedido {
  solicitanteNome: string;
  propostaNumero: string;
  dataSolicitacao: string;
  empresaResponsavelNome: string;
  avaliadorResponsavelNome: string;
  avaliadorCrea: string;
  proponenteNome: string;
  proponenteDocumento: string;
}

export interface AutomaticReportDadosImovel {
  enderecoRua: string;
  enderecoNumero: string;
  enderecoComplemento: string;
  enderecoBairro: string;
  enderecoMunicipio: string;
  enderecoUf: string;
  enderecoCep: string;
  tipoImovel: string;
  matriculaNumero: string;
  matriculaRegistroImoveis: string;
  iptuNumero: string;
  areaConstruida: string;
  areaTerreno: string;
  areaPrivativa: string;
}

export interface AutomaticReportResumoAvaliacao {
  metodologiaAplicada: string;
  grauFundamentacao: string;
  grauPrecisao: string;
  areaPrivativaTotal: string;
  valorUnitarioFinalM2: string;
  valorFinalGarantia: string;
  tipoImovel: string;
}

export interface AutomaticReportAmostra {
  idAmostra: string;
  ranking: number;
  endereco: string;
  tipoImovel: string;
  areaPrivativa: number;
  areaTerreno?: number;
  quartos?: number;
  banheiros?: number;
  vagas?: number;
  idadeAparente?: number;
  valorOferta: string;
  valorUnitarioM2: string;
  urlFonte: string;
  padraoAcabamento: string;
  estadoConservacao: string;
  impressaoGeral: string;
  imagemUrl?: string;
}

export interface AutomaticReportCalculoItem {
  id: number;
  area: string;
  valorUnit: string;
  fat: string;
  san: string;
  valorHomog: string;
}

export interface AutomaticReportCalculos {
  legendaFatores: string;
  tabelaCalculo: AutomaticReportCalculoItem[];
  mediaValorUnitarioOriginal: string;
  mediaValorHomogeneizado: string;
}

export interface AutomaticReportHomogeneizacao {
  nElementos: string;
  valorUnitarioMedio: string;
  limiteInferior30: string;
  limiteSuperior30: string;
}

export interface AutomaticReportSaneamento {
  nElementosSaneado: string;
  valorUnitarioMedioSaneado: string;
  limiteInferiorSaneado30: string;
  limiteSuperiorSaneado30: string;
  desvioPadrao: string;
  coefVariacao: string;
  tStudent: string;
  intervaloConfiabilidade: string;
  campoArbitrio: string;
}

export interface AutomaticReportAvaliacaoFinal {
  valorEstimado: string;
  valorMinimo: string;
  valorMaximo: string;
  valorM2Medio: string;
  valorAvaliacao: string;
  valorAvaliacaoGarantia: string;
  valorGarantiaLeilao: string;
}

export interface AutomaticReportMetodologia {
  nome: string;
  descricao: string;
  amostrasUtilizadas: number;
  codigoParecer: string;
}

export interface AutomaticReportData {
  header: AutomaticReportHeader;
  dadosPedido: AutomaticReportDadosPedido;
  dadosImovel: AutomaticReportDadosImovel;
  resumoAvaliacao: AutomaticReportResumoAvaliacao;
  amostras: AutomaticReportAmostra[];
  calculosAvaliatorios: AutomaticReportCalculos;
  homogeneizacao: AutomaticReportHomogeneizacao;
  saneamento: AutomaticReportSaneamento;
  avaliacaoFinal: AutomaticReportAvaliacaoFinal;
  observacoes: string;
  metodologia: AutomaticReportMetodologia;
}

export interface AutomaticReportResponse {
  inspectionItemId: string;
  aiAnalysisJobId: string;
  status: string;
  reportData?: AutomaticReportData;
  errorMessage?: string;
  completedAt?: string;
}
